export default "__VITE_ASSET__Bcbr2FCW__"